import { useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { SingleValue } from 'react-select';

import { LINKS } from '@/constants/LINKS';

import { renderMultilineText } from '@/utils/renderMultilineText';
import { getContactOptions } from '@/utils/getContactOptions';

import { Button } from '@/components/Button';
import { ContactOption, ContactSelect } from '../ContactSelect';

import styles from './OrderForm.module.scss';

export function OrderForm() {
  const { t } = useTranslation('orderForm');

  const contactOptions = getContactOptions(t);

  const [contact, setContact] = useState(contactOptions[0]);

  const handleContactChange = (selectedOption: SingleValue<ContactOption>) => {
    if (selectedOption) {
      setContact(selectedOption);
    }
  };

  return (
    <form className={clsx(styles.orderForm)}>
      <p className={styles.orderForm__description}>{renderMultilineText(t('description'))}</p>
      <div className={styles.orderForm__inputs}>
        <ContactSelect
          isForModal={true}
          options={contactOptions}
          value={contact}
          onChange={handleContactChange}
        />
      </div>
      <a href={LINKS[contact.value as keyof typeof LINKS]} target="_blank" rel="noreferrer">
        <Button className={styles.orderForm__button}>{t('contactNow')}</Button>
      </a>
    </form>
  );
}
